import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './RestaurantsSmallBanner.css';
import React, { memo, useState } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import RouterLink from '../atoms/RouterLink';
import { isNil } from '../../utils/IsNil';
import { ReactComponent as IconChevronDown } from "../../resources/icons/IconChevronDown.svg";
var RestaurantsSmallBanner = /*#__PURE__*/memo(function (_ref) {
  var fields = _ref.fields;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var title = get(fields, 'data.datasource.title.jss.value');
  var text = get(fields, 'data.datasource.text.jss.value');
  var imageSrc = get(fields, 'data.datasource.image.jss.value.src');
  var imageAlt = get(fields, 'data.datasource.image.jss.value.alt');
  var href = get(fields, 'data.datasource.link.jss.value.href');
  var buttonText = getDictionaryItem(get(fields, 'data.moduleDictionary'), 'ButtonText') || '';
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('RestaurantsSmallBanner component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [RestaurantsSmallBanner component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "bannerWrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: imageAlt,
    className: "bannerImage"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cardInfo"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "subTitle"
  }, text), /*#__PURE__*/React.createElement(RouterLink, {
    className: "ctaButton",
    href: href,
    linktype: "external",
    openInSameTab: true
  }, buttonText, /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })))));
});
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "cexw5qq";
var ltrStyles = "lvrky7c";
var rtlStyles = "rn5doc2";
export default RestaurantsSmallBanner;